<div class="wrap wrapMain coverPathWidget">
  <form class="coverPathForm" id="beneForm" [formGroup]="beneForm">
    <div class="formRow">
      <div class="split-row-col2">
        <div class="colLeft">
          <div class="formRow">
            <label for="name" class="headerLabel">Full Name</label>
            <div class="contentPadding">
              <basic-text-input
                [propertyName]="'name'"
                [placeholder]="'Name'"
                [parserType]="'Text'"
                [inputType]="'text'"
                type="text"
                formControlName="name"
                [formGroupComponent]="true"
              ></basic-text-input>
              <control-messages [control]="beneForm.controls.name"></control-messages>
            </div>
          </div>

          <div class="formRow">
            <label for="trustDate" class="headerLabel">Date of Trust</label>
            <div class="contentPadding">
              <basic-text-input
                [propertyName]="'trustDate'"
                [placeholder]="'MM/DD/YYYY'"
                [inputMask]="{mask: mask}"
                [parserType]="'Text'"
                [inputType]="'text'"
                type="text"
                formControlName="trustDate"
                [formGroupComponent]="true"
              ></basic-text-input>
              <control-messages [control]="beneForm.controls.trustDate"></control-messages>
            </div>
          </div>

          <div class="formRow">
            <fieldset class="address">
              <div class="groupHeader">
                <label for="headerLabel">
                  Address
                  <span class="optional">(optional)</span>
                </label>
                <button type="button" (click)="resetAddress()">clear address</button>
              </div>
              <div class="split-row-col2 contentPadding">
                <div class="colLeft street contentPadding">
                  <basic-text-input
                    [propertyName]="'street'"
                    [placeholder]="'Address line 1'"
                    [parserType]="'Text'"
                    [inputType]="'text'"
                    type="text"
                    formControlName="street"
                    [formGroupComponent]="true"
                  ></basic-text-input>
                  <control-messages [control]="beneForm.controls.street"></control-messages>
                </div>
                <div class="colRight line1 contentPadding">
                  <basic-text-input
                    [propertyName]="'line1'"
                    [placeholder]="'Address line 2'"
                    [parserType]="'Text'"
                    [inputType]="'text'"
                    type="text"
                    formControlName="line1"
                    [formGroupComponent]="true"
                  ></basic-text-input>
                </div>
              </div>
              <div class="split-row-col2 contentPadding">
                <div class="colLeft line2 contentPadding">
                  <basic-text-input
                    [propertyName]="'line2'"
                    [placeholder]="'Address line 3'"
                    [parserType]="'Text'"
                    [inputType]="'text'"
                    type="text"
                    formControlName="line2"
                    [formGroupComponent]="true"
                  ></basic-text-input>
                </div>
                <div class="colRight city contentPadding">
                  <basic-text-input
                    [propertyName]="'city'"
                    [placeholder]="'City'"
                    [parserType]="'Text'"
                    [inputType]="'text'"
                    type="text"
                    formControlName="city"
                    [formGroupComponent]="true"
                  ></basic-text-input>
                  <control-messages [control]="beneForm.controls.city"></control-messages>
                </div>
              </div>
              <div class="split-row-col2 contentPadding">
                <div class="colLeft state contentPadding">
                  <select-basic
                    [propertyName]="'state'"
                    [placeholder]="'State'"
                    [optionValues]="stateList"
                    formControlName="state"
                    [label]="'State'"
                    [formGroupComponent]="true"
                  ></select-basic>
                </div>
                <div class="colRight zip contentPadding">
                  <basic-text-input
                    [propertyName]="'zip'"
                    [placeholder]="'ZIP'"
                    (valueChanged)="zipCodeLookup()"
                    [parserType]="'Text'"
                    [inputType]="'text'"
                    type="text"
                    formControlName="zip"
                    [formGroupComponent]="true"
                  ></basic-text-input>
                  <control-messages [control]="beneForm.controls.zip"></control-messages>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <div class="colRight">
          <div class="formRow">
            <label for="phone" class="headerLabel">
              Phone Number
              <span class="optional">(optional)</span>
            </label>
            <div class="contentPadding">
              <basic-text-input
                [propertyName]="'phone'"
                [placeholder]="'10 digit phone'"
                (valueChanged)="formatPhone()"
                [parserType]="'Text'"
                [inputType]="'text'"
                type="text"
                formControlName="phone"
                [formGroupComponent]="true"
              ></basic-text-input>
              <control-messages [control]="beneForm.controls.phone"></control-messages>
            </div>
          </div>

          <div class="formRow">
            <label for="email" class="headerLabel">
              Email
              <span class="optional">(optional)</span>
            </label>
            <div class="contentPadding">
              <basic-text-input
                [propertyName]="'email'"
                [placeholder]="'Email Address'"
                [parserType]="'Text'"
                [inputType]="'text'"
                type="text"
                formControlName="email"
                [formGroupComponent]="true"
              ></basic-text-input>
              <control-messages [control]="beneForm.controls.email"></control-messages>
            </div>
          </div>

          <div class="formRow">
            <label class="headerLabel">
              Tax ID
              <span class="optional">(optional)</span>
            </label>
            <div class="info"></div>
            <div class="contentPadding">
              <radio-group
                [propertyName]="'ssnTin'"
                [valueOptions]="taxIdOptions"
                formControlName="ssnTin"
                [formGroupComponent]="true"
              ></radio-group>
              <div class="contentPadding govtId">
                <basic-text-input
                  [propertyName]="'govtId'"
                  [placeholder]="'9 digit ID'"
                  (valueChanged)="formatGovtId()"
                  [parserType]="'Text'"
                  [inputType]="'text'"
                  type="text"
                  formControlName="govtId"
                  [formGroupComponent]="true"
                ></basic-text-input>
                <control-messages [control]="beneForm.controls.govtId"></control-messages>
              </div>
            </div>
          </div>

          <div class="formRow">
            <label class="headerLabel">
              Trust Type
              <span class="optional">(optional)</span>
            </label>
            <div class="contentPadding">
              <radio-group
                [propertyName]="'trustType'"
                [valueOptions]="trustTypeOptions"
                formControlName="trustType"
                [formGroupComponent]="true"
              ></radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="wrap wrapFoot">
  <div class="cta">
    <button type="submit" class="btnSubmit" [disabled]="isDisabled()" (click)="saveBene();">Submit</button>
    <button type="button" class="btnCancel" (click)="cancel();">Cancel</button>
  </div>
</div>
